<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">SJL担当者追加</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                return-object
                url="divisions/kv?type=BU"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="事業部"
                return-object
                url="divisions/kv?type=DEPARTMENT"
                v-model="query.department"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="SJL輸入営業"
                return-object
                url="employees/kv"
                v-model="query.importDirector"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="SJL輸入推進"
                return-object
                url="employees/kv"
                v-model="query.promoteDirector"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId', 'accRepeat'],
  data() {
    return {
      query: {},
      show: false,
      buUrl: `divisions/kv?type=BU&companyId=${this.companyId}`,
      departmentUrl: `divisions/kv?type=DEPARTMENT&companyId=${this.companyId}`
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    save() {
      if (this.accRepeat(this.query)) return
      this.$http
        .post(`/companies/${this.$route.query.id}/add-sjl-acc`, {
          buId: this.getValue(this.query.bu),
          departmentId: this.getValue(this.query.department),
          importDirectorId: this.getValue(this.query.importDirector),
          promoteDirectorId: this.getValue(this.query.promoteDirector)
        })
        .then(() => {
          this.$emit('refresh')
          this.show = false
        })
    },
    getValue(data) {
      return data && data.value
    },
    back() {
      this.query = {}
      this.show = false
    }
  }
}
</script>
